var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/emoji-picker/modifier-picker.tsx";
import React from 'react';
import { Emoji } from './emoji-picker-dropdown';
import ModifierPickerMenu from './modifier-picker-menu';

const backgroundImageFn = () => require('emoji-datasource/img/twitter/sheets/32.png');

const ModifierPicker = _ref => {
  let {
    active,
    modifier,
    onOpen,
    onClose,
    onChange
  } = _ref;

  const handleClick = () => {
    if (active) {
      onClose();
    } else {
      onOpen();
    }
  };

  const handleSelect = modifier => {
    onChange(modifier);
    onClose();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "emoji-picker-dropdown__modifiers",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: modifier,
    onClick: handleClick,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ModifierPickerMenu, {
    active: active,
    onSelect: handleSelect,
    onClose: onClose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }));
};

export default ModifierPicker;